<template>
  <div id="app">
    <!-- <router-view /> -->
    <Index />
  </div>
</template>

<script>
import Index from "@/views/layout/layout";
export default {
  name: "App",
  components: { Index },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue